import React, {useEffect, useState} from "react"
import {apiGetEvents} from "./Actions";
import TableData from "./TableData";
import {Filter} from "./Filter";
import Widget from "../../components/widget";
import {Button} from "../../components/My/Button";
import ArenaEventsModal from "./ArenaEventsModal";
import Toast from "cogo-toast";
import {useSelector} from "react-redux";

const ArenaEvents = () => {

    let [arenaModal, setArenaModal] = useState(false)
    let [loading, setLoading] = useState(false)
    let [data, setData] = useState(null)
    let [subjectId, setSubjectId] = useState(null)


    let subjects = useSelector(state => state.subjects)

    useEffect(() => {
        if (subjects?.data?.length === 1 && !data) {
            getEvent({subjectId: subjects?.data[0]?.value})
        }
    }, [subjects]);


    const getEvent = (values) => {
        setData(null)
        setLoading(true)
        apiGetEvents(values.subjectId, data => {
            setData(data)
            setLoading(false)
            setSubjectId(values.subjectId)
        }, error => {
            Toast.error(error?.message)
            setLoading(false)
        })
    }

    return (
        <>
            <Filter getEvent={getEvent} loading={loading} setData={setData}/>
            <div className={"widget w-full p-4 mb-4 rounded-lg bg-blue-100 border border-grey-100"}>
                <p><span className="font-bold">Stáhnout</span> - Stáhne všechny barcody, které jsou k akci přiřazeny.
                    Lze i opakovaně.</p>
                <p><span className="font-bold">Vložit externí</span> - Naimportuje externí kódy k akci ze souboru csv.
                    Lze i opakovaně.</p>
                <p><span className="font-bold">Importovat</span> - Provede import všech kódů, které jsou u akce
                    vytvořený/vloženy importem. Lze i opakovaně.</p>
            </div>
            {data &&
                <Widget title={<div className={"text-xl"}>Události</div>}
                        right={<Button text={"Vytvořit událost"} onClick={() => setArenaModal(true)}
                        />}>
                    <TableData data={data} subjectId={subjectId} close={(refresh) =>  refresh && getEvent({subjectId: subjectId})}/>
                </Widget>
            }

            <ArenaEventsModal
                visible={arenaModal}
                subjectId={subjectId}
                close={() => {
                    setArenaModal(false)
                    getEvent({subjectId: subjectId})
                }}/>

        </>
    )
}

export default ArenaEvents
